import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Text, FormElements } from '@custom-components';
import { Formik } from 'formik';
import { OverflowContainer, PulseWrapper, ProfileContainer, UserInfo } from '../List.styles';
import { ToastContext } from '../../../../components/ToastWrapper';

class FeatureFlagOrgTable extends PureComponent {
  activateFeatureFlagMapping = async (organizationId, featureFlagId, active, orgName) => {
    const { mutations } = this.props;
    const { updateList, activateFeatureFlagMapping } = mutations;
    const { createToast } = this.context;
    try {
      await activateFeatureFlagMapping(organizationId, featureFlagId, active, orgName);
      createToast(`${orgName} successfully ${active ? 'activated' : 'deactivated'}`, { variant: 'success' });
      await updateList();
    } catch {
      createToast('Something went wrong, please try again.', { variant: 'error' });
    }
  };

  renderRows = () => {
    const { data } = this.props;
    if (!data) return null;
    return data.map((featureOrg) => {
      const { organization, active, featureFlag, id } = featureOrg;
      return {
        id,
        orgName: (
          <ProfileContainer>
            <UserInfo>
              <Text.CopyBody weight="bold" tagName="p" noMargins>
                {organization.name}
              </Text.CopyBody>
            </UserInfo>
          </ProfileContainer>
        ),
        orgEmail: (
          <div>
            <Text.CopyParagraph tagName="span">
              {organization.emailAddress ? organization.emailAddress : ''}
            </Text.CopyParagraph>
          </div>
        ),
        active: (
          <div>
            <Formik initialValues={{ active }}>
              {({ values, setFieldValue }) => (
                <FormElements.Switch
                  name="featureActivated"
                  id="featureActivated"
                  checked={values.active}
                  onChange={async (event, checked) => {
                    setFieldValue('active', !!checked);
                    this.activateFeatureFlagMapping(organization.id, featureFlag.id, checked, organization.name);
                  }}
                />
              )}
            </Formik>
          </div>
        )
      };
    });
  };

  render() {
    return (
      <OverflowContainer>
        <PulseWrapper>
          <Table
            minTableWidth="100%"
            headerCellsConfig={{ roles: { width: '200px' } }}
            rows={[
              { id: 'OrgName', label: 'Customer Name' },
              { id: 'OrgEmail', label: 'Email' },
              { id: 'active', label: 'Active' }
            ]}
          >
            {this.renderRows()}
          </Table>
        </PulseWrapper>
      </OverflowContainer>
    );
  }
}

FeatureFlagOrgTable.contextType = ToastContext;

FeatureFlagOrgTable.propTypes = {
  data: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  mutations: PropTypes.objectOf(PropTypes.func).isRequired
};

export default FeatureFlagOrgTable;
